import { Component } from '@angular/core';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldBaseComponent } from '../base-component';
import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskDirective } from '../../../forms/directives/currency-mask.directive';

@Component({
  selector: 'app-lib-ff-currency',
  styleUrls: ['./currency.component.scss'],
  templateUrl: './currency.component.html',
  imports: [
    NgClass,
    FormsModule,
    CurrencyMaskDirective,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlyCurrencyFieldComponent extends FieldBaseComponent {
  public static defaultOptions: FormlyFieldConfig = {
    defaultValue: 0,
    props: {
      addonStart: '£',
      min: 0,
    },
  };
}
